import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { donHangChiTietApi } from "../../../api/don-hang/donHangChiTietApi";
import { ICommonRequest } from "../../../model/request/ICommonRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IDonHangChiTiet } from "../../../model/respone/don-hang/IDonHangChiTiet";
import { eDonHangChiTietActionTypeIds, IDonHangChiTietActions } from "../../action-types/don-hang/IDonHangChiTietActions";
import { rootActions } from "../../actions/rootActions";

const mainAction = rootActions.donHang.donHangChiTiet;

export function* donHangChiTietSaga(): any {
    // Use takeLatest for LOAD_START action
    yield takeLatest(eDonHangChiTietActionTypeIds.LOAD_START, loadWorker);

    // Use takeLatest for LOAD_DON_HANG_START action (separate action type)
    yield takeLatest(eDonHangChiTietActionTypeIds.LOAD_DON_HANG_START, loadByDonHangWorker);

    // Use takeEvery for other actions
    yield takeEvery(eDonHangChiTietActionTypeIds.SAVE_START, saveWorker);
    yield takeEvery(eDonHangChiTietActionTypeIds.DELETE_START, deleteWorker);
}
function* loadWorker(action: IDonHangChiTietActions): any {
    try {
        const res: IBaseRespone = yield call(donHangChiTietApi.SelectAll, action.payload as ICommonRequest);
        if (res.is_success) {
            yield put(mainAction.LOAD_SUCCESS(res.data));
        } else {
            yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"));
        }
    } catch (error: any) {
        yield put(mainAction.LOAD_ERROR(error.message));
    }
}

function* loadByDonHangWorker(action: IDonHangChiTietActions): any {
    try {
        // Get the donHangId from the action payload
        const donHangId = action.payload as number;
        if (!donHangId) {
            yield put(mainAction.LOAD_DON_HANG_ERROR("Invalid order ID"));
            return;
        }

        // Call the API to get order details
        const res: IBaseRespone = yield call(donHangChiTietApi.GetByDonHang, donHangId);

        if (res.is_success) {
            // Dispatch success action with the data
            yield put(mainAction.LOAD_DON_HANG_SUCCESS(res.data));
        } else {
            // Dispatch error action if API call fails
            yield put(mainAction.LOAD_DON_HANG_ERROR(res.message ?? "Có lỗi"));
        }
    } catch (error: any) {
        // Handle any exceptions
        console.error('Error loading order details:', error);
        yield put(mainAction.LOAD_DON_HANG_ERROR(error.message));
    }
}

function* saveWorker(action: IDonHangChiTietActions): any {
    try {
        let res: IBaseRespone;
        const donHangChiTiet = action.payload as IDonHangChiTiet;
        if (donHangChiTiet.id > 0) {
            res = yield call(donHangChiTietApi.Update, donHangChiTiet);
        } else {
            res = yield call(donHangChiTietApi.Insert, donHangChiTiet);
        }
        if (res.is_success) {
            yield put(mainAction.SAVE_SUCCESS(res.data));
        } else {
            yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"));
        }
    } catch (error: any) {
        yield put(mainAction.SAVE_ERROR(error.message));
    }
}

function* deleteWorker(action: IDonHangChiTietActions): any {
    try {
        const res: IBaseRespone = yield call(donHangChiTietApi.Delete, action.payload as number);
        if (res.is_success) {
            yield put(mainAction.DELETE_SUCCESS(res.data));
        } else {
            yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"));
        }
    } catch (error: any) {
        yield put(mainAction.DELETE_ERROR(error.message));
    }
}
